<template>
  <div class="public-lead-form-page">
    <iframe
      :src="leadFormUrl"
      class="lead-form-iframe"
      title="Enquiry Form"
      frameborder="0"
      allow="clipboard-write"
      loading="lazy"
    />
  </div>
</template>

<script>
export default {
  name: "PublicLeadForm",
  computed: {
    leadFormUrl() {
      // const configured = process.env.VUE_APP_LEAD_FORM_URL;
      // if (configured) {
      //   return configured.replace(/\/$/, "");
      // }
      const api = ("https://api.erp.nestoriagroup.com")
        .replace(/\/$/, "");
      return `${api}/lead-form`;
    },
  },
};
</script>

<style scoped>
.public-lead-form-page {
  width: 100%;
  min-height: 100vh;
  margin: 0;
  padding: 0;
  background: #0f172a;
}

.lead-form-iframe {
  display: block;
  width: 100%;
  min-height: 100vh;
  height: 100vh;
  border: 0;
}
</style>
